import styled from 'styled-components';

export const DatePickerWrapper = styled.div`
  padding: 0 0 12px;

  input {
    padding-left: 40px !important;
    padding-right: 16px !important;
  }

  .icon {
    right: auto;
    left: 15px;
  }
`;
